// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileFeed-cls1_Crp","cls2":"ProfileFeed-cls2_nUW ProfileFeed-cls1_Crp"};